import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import {ReactComponent as Logo} from "../../assets/BusNearbyIcon.svg";
import Hidden from "@mui/material/Hidden";
import Tooltip from "@mui/material/Tooltip";
import i18n from "../../../i18nSetup";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LanguageIcon from "@mui/icons-material/Translate";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Menu from "@mui/material/Menu";
import {LANGUAGES_LABEL} from "../../constants";
import MenuItem from "@mui/material/MenuItem";
import {ReactComponent as HopOnLogo} from "../../assets/PoweredByHopon.svg";
import React, {useState} from "react";
import {ReactComponent as RavPassLogo} from "../../assets/RavPassLogo.svg";
import {ReactComponent as RavPassLogoEN} from "../../assets/rav-pass-english.svg";
import {settingQueryParam} from "../../actions/form";
import {resetState, setLanguage} from "../../actions/config";
import {setUrlSearch} from "../../actions/api";
import {connect} from "react-redux";
import {APP_BAR_HEIGHT} from "../../actions/ui";

function AppBarHeader(props) {
  const LogoComponent = (props.dir == 'rtl') ? RavPassLogo : RavPassLogoEN;
  const [languageMenu, setLanguageMenu] = useState(null);

  const handleLanguageIconClick = (event) => {
    const position = event.currentTarget;
    setLanguageMenu(position);
  };

  const handleLanguageMenuLeave = (event) => {
    setLanguageMenu(null);
  };

  const handleLanguageMenuClose = (event) => {
    setLanguageMenu(null);
    const lang = event.currentTarget.lang;

    props.resetState();
    props.settingQueryParam({locale: lang});
    props.setLanguage(lang);
    props.setUrlSearch({});
  };
  return (
    <AppBar position="absolute"
            sx={{backgroundColor: 'white', color: 'black', justifyContent: 'space-between', flexDirection: 'row', height: APP_BAR_HEIGHT}}>
      <Toolbar>
        <a href={'https://ravkav.ravpass.com/web'} target='_blank'
           style={{display: 'flex', flexDirection: 'row', textDecoration: 'none'}}>
          <Logo alt="לוחות זמנים, תכנון נסיעה ותשלום מהנייד באוטובוסים ורכבות - הורד את האפליקציית רב-פס"
                style={{width: 40, height: 40}}/>
          <Hidden smDown>
            <Tooltip title={i18n.t('hoponLink')}>
              <Typography noWrap variant="h5" sx={{marginLeft: 2, marginRight: 2, color: 'black'}}>
                {i18n.t('nearBus')}
              </Typography>
            </Tooltip>
          </Hidden>
        </a>
        <Tooltip title={i18n.t('changeLanguage')} enterDelay={300}>
          <Button
            color="inherit"
            aria-owns={languageMenu ? 'language-menu' : undefined}
            aria-haspopup="true"
            aria-label='שנה שפה'
            onClick={handleLanguageIconClick}
            data-ga-event-category="header"
            data-ga-event-action="language"
          >
            <LanguageIcon/>
            <ExpandMoreIcon fontSize="small"/>
          </Button>
        </Tooltip>
        <Menu
          id="language-menu"
          anchorEl={languageMenu}
          open={Boolean(languageMenu)}
          onClose={handleLanguageMenuLeave}
        >
          {LANGUAGES_LABEL.map((language) => (
            <MenuItem
              component="a"
              data-no-link="true"
              //href={language.code === 'en' ? canonical : `/${language.code}${canonical}`}
              key={language.code}
              selected={props.userLanguage === language.code}
              onClick={handleLanguageMenuClose}
              lang={language.code}
              hrefLang={language.code}
            >
              {language.text}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
      <a href={'https://ravkav.ravpass.com/web'} target='_blank'
         style={{display: 'flex', flexDirection: 'row', textDecoration: 'none'}}>
        <Tooltip title={i18n.t('ravPassLink')}>
          <LogoComponent style={{height: 34, width: 190, verticalAlign: 'center', alignSelf: 'center'}}/>
        </Tooltip>
      </a>
      <Hidden smDown>
        <a href={'https://ravkav.ravpass.com/web'} target='_blank' style={{
          display: 'flex',
          width: 280,
          flexDirection: 'row',
          justifyContent: 'flex-end',
          textDecoration: 'none'
        }}>
          <Tooltip title={i18n.t('hoponLink')}>
            <HopOnLogo style={{
              height: 34,
              width: 90,
              verticalAlign: 'center',
              alignSelf: 'center',
              marginInlineEnd: 20
            }}/>
          </Tooltip>
        </a>
      </Hidden>
    </AppBar>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    dir: state.otp.config.dir,
    userLanguage: state.otp.config.userLanguage,
  }
};
const mapDispatchToProps = {
  settingQueryParam,
  setLanguage,
  setUrlSearch,
  resetState
};
export default connect(mapStateToProps, mapDispatchToProps)(AppBarHeader)